/* ============================================================================
   PANEL FLOTANTE SOBRE EL MAPA

   ══════════════════════════════════════════════════════════════════════════
   PLEGADO SIGUE VIÉNDOSE

   Un panel que desaparece del todo al plegarse deja al piloto sin saber que
   existe: lo pliega una vez y no lo encuentra más.

   Plegado queda la barra con el título, que además dice qué hay adentro —«Ruta
   · 4 puntos»— para no tener que abrirlo solo para mirar.
   ══════════════════════════════════════════════════════════════════════════
   ========================================================================== */

import React from "react";

export default function PanelFlotante({
  titulo,
  resumen = null,
  lado = "izquierda",
  abierto = true,
  onAlternar,
  children,
}) {
  return (
    <section
      className={`panel-flotante panel-flotante--${lado}${abierto ? "" : " es-plegado"}`}
    >
      <button
        type="button"
        className="panel-flotante__barra"
        onClick={onAlternar}
        aria-expanded={abierto}
      >
        <span className="panel-flotante__titulo">{titulo}</span>
        {/* El resumen evita abrirlo solo para mirar cuántos puntos hay. */}
        {resumen && <span className="panel-flotante__resumen">{resumen}</span>}
        <span className="panel-flotante__flecha" aria-hidden="true">
          {abierto ? "▾" : "▸"}
        </span>
      </button>

      {abierto && (
        <div className="panel-flotante__cuerpo">{children}</div>
      )}
    </section>
  );
}
